export default __webpack_public_path__ + "static/media/beep.75d4b67b.mp3";